import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useCourtCreation } from "@/pages/system-settings/tabs/courts/vienna/hooks/useCourtCreation";
import { useTranslation } from "@/translations";

import { CourtFormFields } from "./court-form-fields/CourtFormFields";

interface Props {
  onClose: () => void;
}

export function CourtCreationDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const { formik } = useCourtCreation(onClose);

  return (
    <FormDialog
      title={t("settings.courts.create.dialogTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
      submitDisabled={!formik.dirty}
      paperSx={{ width: 1200 }}
    >
      <CourtFormFields formik={formik} />
    </FormDialog>
  );
}
